import { Link } from "gatsby";
import PageSection from "@components/PageSection";
import { FlexBox } from "@styles";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import styled from "styled-components";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import SafeImage from "@components/SafeImage";
import { GetThumbnailImage } from "@services/ProductImages";

import "swiper/css";
import "swiper/css/pagination";

const ISwiper = styled(Swiper)`
  width: 90%;

  .swiper-pagination-bullet {
    padding: 0.4rem;
    background-color: #000;
  }
  @media (max-width: 768px) {
    width: 70%;
  }
`;

const CtaButton = styled.button`
  height: max-content;
  outline-color: transparent;
  border: none;
  background: none;
  cursor: pointer;
  z-index: 100;
`;

interface IProps {
  sets: Queries.ProductFragment[];
}
const SetSlider = ({ sets }: IProps) => (
  <PageSection sectionName="Sets">
    <FlexBox justifyContent="center" alignItems="center">
      <CtaButton className="swiper-prev" aria-label="View previous set">
        <FaChevronLeft size={40} />
      </CtaButton>

      <ISwiper
        spaceBetween={10}
        allowSlideNext
        breakpoints={{
          200: {
            slidesPerView: 1,
          },
          750: {
            slidesPerView: 2,
          },
          1075: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        }}
        navigation={{
          prevEl: ".swiper-prev",
          nextEl: ".swiper-next",
        }}
        modules={[Pagination, Navigation]}
      >
        {sets.map((p) => {
          const thumbnail = GetThumbnailImage(p);
          return (
            <SwiperSlide key={p.slug} style={{ alignSelf: "stretch" }}>
              <Link to={`/products/${p.slug}`} style={{ textDecoration: "none" }}>
                <FlexBox direction="column" style={{ alignItems: "center", justifyContent: "center" }} width="325">
                  <SafeImage src={thumbnail?.fullImageUrl} alt={thumbnail?.altText} style={{ height: "10rem", maxWidth: "100%" }} />

                  <p className="text-center underline">{p?.product_name ?? ""}</p>
                </FlexBox>
              </Link>
            </SwiperSlide>
          );
        })}
      </ISwiper>
      <CtaButton className="swiper-next" aria-label="View next set">
        <FaChevronRight size={40} />
      </CtaButton>
    </FlexBox>
  </PageSection>
);

export default SetSlider;
